module.exports = __webpack_public_path__ + "img/qrCodeLog.4695c7d2.png";